import Splide from '@splidejs/splide';

export default class SplideController {
  constructor(host, options) {
    this.host = host;
    this.options = options || {};
    this.splide = null;
    host.addController(this);
  }

  hostConnected() {
    // Controller is connected when host connects
  }

  hostDisconnected() {
    this.destroy();
  }

  hostUpdated() {
    if (this.shouldInitialize() && !this.splide) {
      this.initialize();
    }
  }

  shouldInitialize() {
    const product = this.host.tempProduct || this.host.product;
    return product?.media && product.media.length > 1;
  }

  initialize() {
    const splideElement = this.host.productSliderRef.value;
    if (!splideElement || this.splide) return;

    this.splide = new Splide(splideElement, this.options);
    this.splide.mount();
  }

  refresh() {
    if (this.splide) {
      this.splide.refresh();
    }
  }

  destroy() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
